import { ApiOutlet } from '@vend/types'
import { FEATURE_CROSS_LOCATION_FULFILMENT } from '../constants/wr-features'
import { getFeatureFromCache } from './feature-cache'

export const CLF_ACCOUNT_ATTRIBUTE = 'cross_location_fulfilment_enabled'
export const CLF_SOURCE_OUTLET_ATTRIBUTE =
  'allow_cashiers_to_fulfil_from_elsewhere'
export const CLF_TARGET_OUTLET_ATTRIBUTE =
  'allow_other_outlets_to_reserve_stock'

type OutletAttribute = {
  key?: string
  name?: string
  value?: unknown
}

type OutletWithAttributes = {
  attributes?: OutletAttribute[] | null | undefined
}

const getOutletAttributes = (
  outlet?: OutletWithAttributes | undefined
): OutletAttribute[] | undefined => {
  if (!Array.isArray(outlet?.attributes)) {
    return undefined
  }

  return outlet.attributes
}

export const getOutletAttributeValue = (
  outlet: OutletWithAttributes | undefined,
  requestedAttribute: string
) => {
  const attribute = getOutletAttributes(outlet)?.find(
    attribute =>
      attribute.key === requestedAttribute ||
      attribute.name === requestedAttribute
  )

  if (attribute?.value === null || attribute?.value === undefined) {
    return undefined
  }

  return String(attribute.value)
}

export const isCrossLocationFulfilmentRolloutEnabled = (): boolean =>
  Boolean(getFeatureFromCache(FEATURE_CROSS_LOCATION_FULFILMENT))

export const isCrossLocationFulfilmentAccountEnabled = (
  retailerSettings?: object | undefined
): boolean => {
  const value = (retailerSettings as
    | { [CLF_ACCOUNT_ATTRIBUTE]?: unknown }
    | undefined)?.[CLF_ACCOUNT_ATTRIBUTE]

  return value === true || value === 'true'
}

export const isSourceOutletCrossLocationFulfilmentEnabled = (
  outlet?: OutletWithAttributes | undefined
): boolean =>
  !!outlet &&
  getOutletAttributeValue(outlet, CLF_SOURCE_OUTLET_ATTRIBUTE) !== 'false'

export const isTargetOutletCrossLocationFulfilmentEligible = (
  outlet?: OutletWithAttributes | undefined
): boolean =>
  !!outlet &&
  getOutletAttributeValue(outlet, CLF_TARGET_OUTLET_ATTRIBUTE) !== 'false'

export const filterEligibleCrossLocationFulfilmentTargetOutlets = <
  TOutlet extends ApiOutlet
>(
  outlets: TOutlet[]
): TOutlet[] => outlets.filter(isTargetOutletCrossLocationFulfilmentEligible)
